import React from 'react';
import { useTranslation } from 'react-i18next';

import './PaymentStatusModal.css';

export default function PaymentStatusModal({
  status,
  onClose,
  onRetry,
  onGoToDashboard,
  onChangePaymentMethod,
}) {
  const { t } = useTranslation();
  if (!status) return null;

  const isSuccess = status.type === 'success';
  const isCreditsFlow = status.flow === 'credits';

  return (
    <div className="payment-status-overlay" onClick={onClose} role="presentation">
      <div
        className="payment-status-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={isSuccess ? t('Paiement confirmé') : t('Paiement échoué')}
      >
        <button
          type="button"
          className="payment-status-close"
          aria-label={t('Fermer la fenetre')}
          onClick={onClose}
        >
          x
        </button>

        {isSuccess ? (
          <>
            <p className="payment-status-badge payment-status-badge--success">{t('Success')}</p>
            <h2 className="payment-status-title">{t('Paiement confirmé')}</h2>
            <p className="payment-status-text">{t('Votre paiement a été validé avec succès')}</p>
            <div className="payment-status-details">
              {!isCreditsFlow && <p>{t('Offre activée :')} {status.planName}</p>}
              <p>{t('Crédits ajoutés :')} {status.credits}</p>
              <p>{t('Date :')} {status.date}</p>
            </div>
            <p className="payment-status-text">
              {isCreditsFlow
                ? t('Vos crédits sont disponibles dès maintenant dans votre espace.')
                : t('Vous pouvez dès maintenant profiter de toutes les fonctionnalités de Typix Neo.')}
            </p>
            <button
              type="button"
              className="payment-status-btn payment-status-btn--primary"
              onClick={onGoToDashboard}
            >
              {t('Accéder à mon espace')}
            </button>
          </>
        ) : (
          <>
            <p className="payment-status-badge payment-status-badge--cancel">{t('Cancel')}</p>
            <h2 className="payment-status-title">{t('Paiement échoué')}</h2>
            <p className="payment-status-text">{t("Le paiement n'a pas pu être finalisé.")}</p>
            <p className="payment-status-text">{t("Pas d'inquiétude, aucun montant n'a été prélevé.")}</p>
            <p className="payment-status-text">{t('Vous pouvez réessayer en quelques secondes.')}</p>
            <div className="payment-status-actions">
              <button
                type="button"
                className="payment-status-btn payment-status-btn--primary"
                onClick={onRetry}
              >
                {t('Réessayer le paiement')}
              </button>
              <button
                type="button"
                className="payment-status-btn payment-status-btn--secondary"
                onClick={onChangePaymentMethod || onClose}
              >
                {t('Changer de moyen de paiement')}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
